import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ReportsSection from "../../Sections/Reports";

const ReportsComponents = () => {
    return (
        <Dashboard sectionName={<ReportsSection />}/>
    );
};

export default ReportsComponents;


